import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { Chip, Typography, Paper, Box, Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {  useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [categories, setCategories] = useState([])
  const [onboardlist, setOnboardlist] = useState([])
  const [loader, setLoader] = useState(true)
  const navigate = useNavigate()
  const { folder_id } = useParams()

  const getCategories = async () => {
    const { response } = await AppService.onboardlistcategory.filter({
      query: `folder_id=${folder_id}&type=superadmin`,
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
  }

  const getChecklists = async () => {
    const { response } = await AppService.onboarding_list.getOnboardList({
      query:"type=superadmin"
,
      toaster: false,
    })
    if (response) {
      setOnboardlist(response.data)
    } else {
      setOnboardlist([])
    }
  }

  const onLoad = async () => {
    setLoader(true)
    await Promise.all([getCategories(), getChecklists()])
    setLoader(false)
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.onboardlistcategory.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(() => {
    onLoad()
  }, [])

  const onboardlistByCategory = categories?.map(category => {
    const categoryOnboardlist = onboardlist.filter(
      onboardlist => onboardlist?.category_id === category?._id
    )

    return {
      ...category,
      onboardlist: categoryOnboardlist
    }
  })

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Category', accessor: 'category' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Status', accessor: 'status' },

        { Header: 'Onboardlist', accessor: 'onboardlist' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: onboardlistByCategory.map((category) => ({
        category: category.name,
        type: category.type,
        status: category.status,
        onboardlist: (
          <Box sx={{ width: '100%', minWidth: '300px' }}>
            <Paper
              elevation={1}
              sx={{
                width: '130%',
                p: 2,
                borderRadius: '8px',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              {category?.onboardlist?.length > 0 ? (
                <Box sx={{ width: '100%' }}>
                  {category?.onboardlist?.map((onboardlist, index) => (
                    <Box key={onboardlist?._id}>
                      <Chip
                        label={onboardlist?.name}
                        variant="outlined"
                        sx={{
                          width: '100%',
                          height: 40,
                          borderRadius: 1,
                          justifyContent: 'flex-start',
                          fontSize: '0.875rem',
                          '& .MuiChip-label': {
                            overflow: 'visible',
                            whiteSpace: 'nowrap'
                          },
                        }}
                      />
                      {index < category?.onboardlist?.length - 1 && (
                        <Divider sx={{
                          my: 1,
                          borderColor: '#000000',
                          borderBottomWidth: 10,
                          opacity: 1
                        }} />
                      )}
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="outlined">
                  No Onboard items available
                </Typography>
              )}
            </Paper>
          </Box>
        ),
        action: (
          <MDBox sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <EditModal data={category} handleRefresh={onLoad} />
            <MDButton
              variant="gradient"
              color="warning"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${category?._id}/${category?.type}`, { state: category })}
            >
              View
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(category?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}